export default {
  labels: {
    name: '(Company)name',
    street: 'Street',
    house_number: 'House number',
    zip: 'Zip code',
    city: 'City',
    phone_number: 'Phone number',
    vat_number: 'VAT-number',
    extra: 'Additional information'
  },
  placeholders: {
    name: 'eg Ligo B.V.',
    street: 'eg Stadhouderskade',
    house_number: 'e.g. 60',
    zip: 'eg 1072 AC',
    city: 'eg Amsterdam',
    phone_number: 'e.g. 020-3031043',
    vat_number: 'Optional',
    extra: 'Optional'
  },
  tooltips: {}
};
